export const CONTACT_EMAIL = "bemina@frenchpie.co.in";
export const CONTACT_PHONE = "+91 95967 66336";
export const CONTACT_PHONE_HREF = "tel:+919596766336";
export const CONTACT_ADDRESS = "Havells Galaxy, Sector 3, Shamasabad, Bemina, Srinagar — 190018";

const unsplash = (id, w = 900) => `https://images.unsplash.com/${id}?q=80&auto=format&fit=crop&w=${w}`;
const pexels = (id, w = 900) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const MENU_TABS = [
  { id: "viennoiseries", label: "Viennoiseries" },
  { id: "tarts", label: "Pies & Tarts" },
  { id: "savory", label: "Savory Bakes" },
  { id: "coffee", label: "Coffee & More" },
];

export const MENU = {
  viennoiseries: [
    { name: "Croissant au Beurre", price: 180, desc: "72-hour cold-fermented dough folded with French butter. Shattering crust, honeycomb crumb.", tag: "Signature", img: pexels(13743229) },
    { name: "Pain au Chocolat", price: 200, desc: "Two batons of dark chocolate tucked into buttery laminated layers.", img: unsplash("photo-1599940778173-e276d4acb2bb") },
    { name: "Brioche Feuilletée", price: 190, desc: "Feather-light, layered, brushed with caramelised butter.", img: unsplash("photo-1620830958756-46335282c574") },
    { name: "Chausson aux Pommes", price: 210, desc: "Hand-folded apple turnover with cinnamon and Normandy butter.", img: unsplash("photo-1571157577110-493b325fdd3d") },
  ],
  tarts: [
    { name: "La Tourte French Pie", price: 360, desc: "Our namesake: vanilla custard in a brown-butter shell.", tag: "House Icon", img: unsplash("photo-1541781622821-8af65b6b449f") },
    { name: "Tarte au Citron Meringuée", price: 320, desc: "Sharp lemon cream under a torched Swiss meringue cloud.", img: unsplash("photo-1541780234649-a3d8c21e2d8b") },
    { name: "Mille-Feuille", price: 340, desc: "Caramelised puff, crème pâtissière, a restrained glaze.", img: unsplash("photo-1541779774450-da0f04dd9080") },
    { name: "Tarte Fruits Rouges", price: 380, desc: "Berries on vanilla crème légère, glazed to shine.", tag: "Seasonal", img: pexels(32802351) },
  ],
  savory: [
    { name: "Quiche Lorraine", price: 290, desc: "Lardons, cream, a slow bake and a wobbly centre.", img: unsplash("photo-1751151856149-5ebf1d21586a") },
    { name: "Feuilleté Jambon-Fromage", price: 260, desc: "Ham and Comté in crisp puff with béchamel.", img: pexels(35095957) },
    { name: "Baguette Tradition", price: 140, desc: "Pointed, scored, baked on stone. The daily loaf.", img: unsplash("photo-1585219644804-af713376a976") },
  ],
  coffee: [
    { name: "Café Crème", price: 180, desc: "Espresso stretched with steamed milk, French café style.", img: unsplash("photo-1567309966795-5ad24aa39971") },
    { name: "Café Gourmand", price: 320, desc: "Espresso with a flight of three mini pastries.", tag: "Afternoon", img: unsplash("photo-1534234757579-8ad69d218ad4") },
    { name: "Noisette", price: 160, desc: "Espresso with a whisper of milk. The Parisian shot.", img: unsplash("photo-1497636577773-f1231844b336") },
    { name: "Chocolat Chaud à l'Ancienne", price: 240, desc: "Dark chocolate melted into whole milk, whipped cream on top.", img: pexels(6747870) },
  ],
};

export const ORDER_ITEMS = [
  { name: "Croissant au Beurre", price: 180 },
  { name: "Pain au Chocolat", price: 200 },
  { name: "La Tourte French Pie", price: 360 },
  { name: "Mille-Feuille", price: 340 },
  { name: "Quiche Lorraine", price: 290 },
  { name: "Baguette Tradition", price: 140 },
];

export const FALLBACK_ITEM_IMG = pexels(30853716);

export const MARQUEE_ITEMS = ["Croissants au beurre", "Tartes de saison", "Pain au chocolat", "Quiches du matin", "Mille-feuilles", "Café gourmand"];

export const OUTLETS = [
  {
    id: "srinagar",
    city: "Srinagar",
    area: "Bemina",
    badge: "Flagship",
    address: "Havells Galaxy, Sector 3, Shamasabad, Bemina, Srinagar, Jammu & Kashmir 190018",
    hours: "10:00 AM — 10:00 PM · All days",
    signature: "La Tourte French Pie",
    lat: 34.0763543,
    lng: 74.7681595,
  },
];

export const GALLERY = [
  { src: "https://customer-assets-lqy194kg.emergentagent.net/job_fresh-bake-hub-6/artifacts/g8473r0u_WhatsApp%20Image%202026-09-23%20at%206.25.48%20PM%20%281%29.jpeg", alt: "The dining room — sage panels under lantern light.", cls: "col-span-2 row-span-2" },
  { src: "https://customer-assets-lqy194kg.emergentagent.net/job_fresh-bake-hub-6/artifacts/937he2an_WhatsApp%20Image%202026-09-23%20at%206.25.49%20PM.jpeg", alt: "Our chef at the celebration cake counter.", cls: "" },
  { src: "https://customer-assets-lqy194kg.emergentagent.net/job_fresh-bake-hub-6/artifacts/mw27t55u_WhatsApp%20Image%202026-09-23%20at%206.25.48%20PM.jpeg", alt: "Brick, bamboo and the evening tables.", cls: "" },
  { src: "https://customer-assets-lqy194kg.emergentagent.net/job_fresh-bake-hub-6/artifacts/mdxh6mmg_WhatsApp%20Image%202026-09-23%20at%206.25.50%20PM.jpeg", alt: "Red velvet, boxed for a birthday.", cls: "" },
  { src: unsplash("photo-1549413468-cd78edb7e75c", 1200), alt: "Country loaves, rested overnight on jute.", cls: "" },
  { src: pexels(35993723, 1200), alt: "Shelves set before the doors open.", cls: "col-span-2" },
  { src: pexels(36444996, 1200), alt: "The stone oven keeps its own time.", cls: "" },
  { src: pexels(28164993, 1200), alt: "Baguettes, seven minutes to go.", cls: "" },
];

export const HERO_IMAGE = "https://customer-assets-lqy194kg.emergentagent.net/job_fresh-bake-hub-6/artifacts/o9hmu61z_WhatsApp%20Image%202026-09-23%20at%206.21.34%20PM.jpeg";
export const HERO_POLAROID = unsplash("photo-1541781550486-81b7a2328578", 800);
export const QR_MENU_IMAGE = "https://customer-assets-lqy194kg.emergentagent.net/job_fresh-bake-hub-6/artifacts/z12au3li_WhatsApp%20Image%202026-09-23%20at%206.25.52%20PM.jpeg";
export const QR_MENU_LINK = QR_MENU_IMAGE;

export const MANIFESTO_CHAPTERS = [
  {
    num: "01",
    label: "L'Origine",
    title: "Every night, our dough sleeps.",
    body: "Cold fermentation for 72 hours. No shortcuts, no improvers — time does the lifting long before our ovens do. It's slower. It's also the whole point.",
    img: unsplash("photo-1732565649629-eb4932a1ec09", 1200),
    alt: "Baker sprinkling flour over rested dough",
    offset: "",
  },
  {
    num: "02",
    label: "Le Feuilleté",
    title: "Layer upon layer of French butter.",
    body: "Lamination is a discipline: butter sheet, dough sheet, fold, rest, repeat — until the dough shatters, then melts. You can hear a good croissant before you taste it.",
    img: pexels(30853716, 1200),
    alt: "Rows of golden croissants fresh from the oven",
    offset: "lg:mt-16",
  },
  {
    num: "03",
    label: "La Transmission",
    title: "One recipe book, every outlet.",
    body: "A French Pie baker trains for months before touching the lamination bench. When a new outlet opens, we don't ship pastries to it — we send the craft.",
    img: unsplash("photo-1517686469429-8bdb88b9f907", 1200),
    alt: "Baker rolling laminated dough beside a rolling pin",
    offset: "",
  },
];

export const REVIEWS = {
  main: { quote: "\"The croissant that ruined every other croissant for me.\"", by: "Marion D. — Regular since the first batch" },
  side: [
    { quote: "\"Lamination this precise belongs in a museum — or a very happy mouth.\"", by: "Le Journal Gourmand — Press review", dark: false },
    { quote: "\"I queue every Sunday before the tarts land at nine sharp.\"", by: "Tomás R. — Neighbour & loyalist", dark: true },
  ],
};

export const MAP_DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=Havells%20Galaxy%2C%20Sector%203%2C%20Shamasabad%2C%20Bemina%2C%20Srinagar%2C%20Jammu%20%26%20Kashmir%20190018";

export const CATALOG = Object.fromEntries(
  [...ORDER_ITEMS, ...Object.values(MENU).flat()].map(
    (i) => [i.name, { price: i.price, desc: i.desc || "", img: i.img || null }],
  ),
);
